function getCurrenySymbol(CurrenyCode) {
  	var CurrenyCode = getCookie('cart_currency');
      var currency_symbol;
      switch(CurrenyCode) {
// for now we have only single currency*- USD

        case 'USD':
          currency_symbol = '$';
          break;
          
        case 'EUR':
          currency_symbol = '€';
          break;

        case 'HKD':
          currency_symbol = 'HK$';
          break;

        default:
          currency_symbol = '£';
      }
      
      return currency_symbol;
    }
/************************** Start - Diamond Carat Filter **************************/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat=[];

for(i=minDiamondCarat;i<1;i=i+0.01)
{
  var dec=i.toFixed(2);
  carat.push(dec);
}
for(i=1;i<2;i=i+0.10)
{
  var dec=i.toFixed(2);
  carat.push(dec);
}
for(i=2;i< maxDiamondCarat;i=i+0.15)
{
  var dec=i.toFixed(2);
  carat.push(dec);
}
carat.push(maxDiamondCarat);
// for(i=5;i<=15;i=i+0.50)
// {
//   var dec=i.toFixed(2);
//   carat.push(dec);
// }
 Shopify.money_format = '&pound;{{amount}}';
var currency_symbol ="£";

function getClosestNum(num, ar)
{
  //console.log(ar);
  var i = 0, closest, closestDiff, currentDiff;
  if(ar.length)
  {
    closest = ar[0];
    for(i;i<ar.length;i++)
    {           
      closestDiff = Math.abs(num - closest);
      currentDiff = Math.abs(num - ar[i]);
      if(currentDiff < closestDiff)
      {
        closest = ar[i];
      }
      closestDiff = null;
      currentDiff = null;
    }
    //returns first element that is closest to number
    return closest;
  }
  //no length
  return false;
}
  
function get_index(value,array){
  
  var pos=0
  for (i=0;i<array.length;i++) {
    if(array[i]==value) {
      pos = i;
      break;
    }
  }
  
  return pos;

}
// $(document).ready(function() {
//      $("form.sea-Form").submit(function(){
// 		localStorage.clear();
//     });
//     jQuery('.sea-Form').attr('action','/pages/custom-search');
// });
/* carat fiter start*/
function carat_slider_render(start,end,option){
 
    var start2=getClosestNum(start,carat);
	var end2=getClosestNum(end,carat);
	var start1=get_index(start2,carat); 
	var start11=get_index(start,carat);
	var end11=get_index(end,carat);
	var end1=get_index(end2,carat);
    var settingSelected=jQuery("#setting").val();
  		jQuery("#carat-slider").slider({
			range: true,
			min: 0,
			max: carat.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
              //disable min max slider if setting selected
            if(settingSelected == 1 && (parseFloat(start)  > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])])) ){
               return false; 
            }
             
				$("#carat_from").val(carat[parseInt(ui.values[0])]+' Ct.');
				$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
				$('#carat_to').val(carat[parseInt(ui.values[1])]+' Ct.');
				$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
              
				/* $("#carat_from").val(carat[parseInt(ui.values[0])]+' ct.');
				$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
				$('#carat_to').val(carat[parseInt(ui.values[1])]+' ct.');
				$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]); */
			
              if(option) {	
				   	jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
                   	ajaxDataCall(1);
              }
			}
			 
		});
  start = start ? start : minDiamondCarat;
		 $("#carat_from").val(start+' Ct.');
		 $("#carat_to").val(end+' Ct.');
		 $('#carat_left_hidden').val(start);
		 $('#carat_right_hidden').val(end);	
}


function replace_carat_from(){

  var min_carat_value = minDiamondCarat;
  var settingSelected=jQuery("#setting").val();

  
  if(jQuery('#carat_from').val()==''){
    var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2); 
    jQuery('#carat_from').val(parseFloat(value).toFixed(2)+' Ct.');
    return false;
  } else {
    var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2); 
  	var carat_value= parseFloat(jQuery('#carat_from').val()).toFixed(2); 
  }
  //alert(hidden_carat_value +'-'+carat_value);
//   var value = carat_value.replace(/ct\./g, '');
//   carat_value1_comma = value.replace(/[^0-9\,.]+/g, '');  
//   value = carat_value1_comma.replace(',', '.'); 
  
   var value = carat_value;
  var carat_value1_comma = value;  
  value = carat_value1_comma; 

  var value1=parseFloat($('#carat_to').val());
  
  /*if(value == value1){ 
    //alert('Carat from value should be less than carat to value'); 
    var value = parseFloat(jQuery('#carat_left_hidden').val()); 
    jQuery('#carat_from').val((value.toFixed(2))+' ct.');
    return false;
  } else */
   if(isNaN(value)!=false){
     var value = parseFloat(minDiamondCarat).toFixed(2);
     alert("Please enter value in number");
     jQuery('#carat_from').val(value+' Ct.');
  }
  else if(value > value1){
    alert('Carat from value should be less than carat to value'); 
    $('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' Ct.');
    return false;
  }
  else if(carat_value < min_carat_value){
	 alert('Carat from value should be less than carat from value'); 
    $('#carat_from').val((parseFloat(min_carat_value).toFixed(2))+" Ct.");
    carat_slider_render(min_carat_value,value1,true);
    return false;
  }
  else if(settingSelected == 1 && (hidden_carat_value > carat_value)){
     alert('selected setting can match with diamond greater than '+carat_value);
     jQuery('#carat_from').val(hidden_carat_value+" Ct.");   
    return false; 
   }
  $('#carat_left_hidden').val(value);
  $('#carat_right_hidden').val(value1);

  carat_slider_render(value,value1,true);

}

function replace_carat_to(){
  var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
  var settingSelected=jQuery("#setting").val();
  if(jQuery('#carat_to').val()==''){
    var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2); 
    jQuery('#carat_to').val(parseFloat(value).toFixed(2)+' Ct.');
    return false;
  } else {
    var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2); 
  	var carat_value= parseFloat(jQuery('#carat_to').val()).toFixed(2); 
  }

//   value = carat_value.replace(/ct\./g, '');
//   carat_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = carat_value1_comma.replace(',', '.'); 
  
  value = carat_value;
  var carat_value1_comma = value;   
  value = carat_value1_comma; 

  var value1=parseFloat($('#carat_from').val());


  /*if(value == value1){ 
    //alert('Carat to value should be greater than carat from value'); 
    var value = parseFloat(jQuery('#carat_right_hidden').val()); 
    jQuery('#carat_to').val((value.toFixed(2))+' ct.');
    return false;
  } else */ 
  if(isNaN(value)!=false){
     var value = parseFloat(maxDiamondCarat).toFixed(2);
     alert("Please enter value in number");
     jQuery('#carat_to').val(value+' Ct.');
  }
   else if(parseFloat(value) > parseFloat(max_carat_value))
  {
//     alert(value +'-'+max_carat_value);
	 alert('Carat from value cannot be greater than Max Carat'); 
     jQuery('#carat_to').val(hidden_carat_value+" Ct.");   
    return false; 
  }
  else if(value1 > value){ 
    alert('Carat to value should be greater than carat from value');  
    $('#carat_to').val(hidden_carat_value+' Ct.');
    return false;
  }
//   else if(value > max_carat_value)
//   {
//     $('#carat_to').val((max_carat_value.toFixed(2))+" Ct.");
//     carat_slider_render(value1,max_carat_value,true);
//     return false;
//   }
  
//    else if(value < max_carat_value)
//   {
// 	 alert('Carat from value should be less than carat from value'); 
//      jQuery('#carat_to').val(hidden_carat_value+" Ct.");   
//     return false; 
//   }
  else if(settingSelected == 1 && (hidden_carat_value < carat_value)){
     alert('Selected setting can match with diamond less than '+carat_value);
     jQuery('#carat_to').val(hidden_carat_value+" Ct.");   
    return false; 
   }

  $('#carat_right_hidden').val(value);
  $('#carat_left_hidden').val(value1);
  
  carat_slider_render(value1,value,true);
}

/************************** End - Diamond Carat Filter **************************/


/************************** Start - Diamond Cut Filter **************************/
var min_cut = jQuery( "#cut-min-value" ).val();
var max_cut = jQuery( "#cut-max-value" ).val();
function cut_slider_render(start,end,option){ 
	jQuery("#cut-slider").slider({
			range: true,
			min: 0,
			max: 5,
			values: [ start,end ],
			slide: function( event, ui ) {
           //  alert(1);
              if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	                return false; 
	          }
              jQuery('ul#cut_list li:nth-child('+ui.values[0]+')').addClass('focus');
	          jQuery('ul#cut_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	          for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	          {
	        	  jQuery('ul#cut_list li:nth-child('+ i +')').removeClass('focus');  
	          }
              jQuery( "#cut-min-value" ).val(ui.values[0]);
			  jQuery( "#cut-max-value" ).val(ui.values[1]);
			},
			change: function(event, ui) {
              //  alert(2);
              	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
              	
            }
	});
}
/************************** End - Diamond Cut Filter **************************/

/************************** Start - Diamond Color Filter **************************/
var min_color = jQuery( "#color-min-value" ).val();
var max_color = jQuery( "#color-max-value" ).val();
function color_slider_render(start,end,option){
	jQuery("#color-slider").slider({
      	range: true,
		min: 0,
		max: jQuery("#color-max-value-slide").val(),
      
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#color_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#color_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#color_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#color-min-value" ).val(ui.values[0]);
		  jQuery( "#color-max-value" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
            
        }
    });
}
/************************** End - Diamond Carat Filter **************************/

/************************** Start - Diamond fancy intensity Filter **************************/
var min_fancyintensity = jQuery( "#min_fancyintensity" ).val();
var max_fancyintensity = jQuery( "#max_fancyintensity" ).val();
function fancyIntensity_slider_render(start,end,option){
	jQuery("#intensity-slider").slider({
      	range: true,
		min: 0,
		max: 8,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#intensity_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#intensity_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#intensity_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_fancyintensity" ).val(ui.values[0]);
		  jQuery( "#max_fancyintensity" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
        }
    });
}
/************************** End - Diamond fancy intensity Filter **************************/

/************************** Start - Diamond clarity Filter **************************/
var min_clarity = jQuery( "#clarity-min-value" ).val();
var max_clarity = jQuery( "#clarity-max-value" ).val();
function clarity_slider_render(start,end,option){
	jQuery("#clarity-slider").slider({
      	range: true,
		min: 0,
		max: 9,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#clarity_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#clarity_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#clarity_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#clarity-min-value" ).val(ui.values[0]);
		  jQuery( "#clarity-max-value" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
           
        }
    });
}
/************************** End - Diamond clarity Filter **************************/

/************************** Start - Diamond polish Filter **************************/
var min_polish = jQuery( "#min_polish" ).val();
var max_polish = jQuery( "#max_polish" ).val();
function polish_slider_render(start,end,option){
	jQuery("#polish-slider").slider({
      	range: true,
		min: 0,
		max: 3,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#polish_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#polish_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#polish_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_polish" ).val(ui.values[0]);
		  jQuery( "#max_polish" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
          
        }
    });
}
/************************** End - Diamond polish Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
var min_symmetry = jQuery( "#min_symmetry" ).val();
var max_symmetry = jQuery( "#max_symmetry" ).val();
function symmetry_slider_render(start,end,option){
	jQuery("#symmetry-slider").slider({
      	range: true,
		min: 0,
		max: 3,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#symmetry_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#symmetry_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#symmetry_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_symmetry" ).val(ui.values[0]);
		  jQuery( "#max_symmetry" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
           
        }
    });
}
/************************** End - Diamond Symmetry Filter **************************/

/************************** Start - Diamond fluorescence Filter **************************/
var min_fluorescence = jQuery( "#min_fluorescence" ).val();
var max_fluorescence = jQuery( "#max_fluorescence" ).val();
function fluorescence_slider_render(start,end,option){
	jQuery("#fluorescence-slider").slider({
      	range: true,
		min: 0,
		max: 5,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#fluorescence_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#fluorescence_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
          for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#fluorescence_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_fluorescence" ).val(ui.values[0]);
		  jQuery( "#max_fluorescence" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
           
        }
    });
}
/************************** End - Diamond fluorescence Filter **************************/

/************************** Start - Diamond Price Filter **************************/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();
// for (var i = parseFloat(minDiamondPrice) ; i <= maxDiamondPrice; i = i+50) {
//   price.push(i);
// }
for (var i = parseFloat(minDiamondPrice); i < 7000; i = i+25) {
	price.push(i);
};
// for (var i = 1200; i < 12000; i = i+10) {
// 	price.push(i);
// };
// for (var i = 12000; i < 25000; i = i+250) {
// 	price.push(i);
// };
for (var i = 7000; i < parseFloat(maxDiamondPrice); i = i+500) {
	price.push(i);
};

price.push(parseInt(maxDiamondPrice));

function addCommas(price)
{
        price += '';
		x = price.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
		return x1 + x2;

}

function price_slider_render(start,end,option){
  
    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);
  console.log("closet no start2"+start2);
    console.log("closet no end2"+end2);
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 
   console.log("price index "+start1);
    console.log("price index "+end1);
    
        jQuery("#price-slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ start1,end1 ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
             jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
             jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
             jQuery('#price_from').val(currency_symbol+" "+addCommas(price[parseInt(ui.values[0])].toFixed(0)));
             jQuery('#price_to').val(currency_symbol+" "+addCommas(price[parseInt(ui.values[1])].toFixed(0)));
             
            },
            change: function(event, ui) {
              //console.log(slide);
             /* jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
             jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
             jQuery('#price_from').val(addCommas(price[parseInt(ui.values[0])].toFixed(2)));
             jQuery('#price_to').val(addCommas(price[parseInt(ui.values[1])].toFixed(2))); */
                           
             if(option) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
              slide = '';
            }
             
        });
  		  
          var start_num = parseInt(start);
          var end_num = parseInt(end);
	
          var start_dec= start_num.toFixed(0);
          var end_dec= end_num.toFixed(0);
  
         jQuery('#price_left_hidden').val(start_dec);
         jQuery('#price_right_hidden').val(end_dec);
  		 jQuery('#price_from').val(currency_symbol+" "+addCommas(start_dec));  
  		 jQuery('#price_to').val(currency_symbol+" "+addCommas(end_dec));
}

function get_priceindex(value){
    var pos=0
    for (i=0;i<price.length;i++) {
        if(price[i]==value) {
            pos = i;
            break;
        }
    }
    return pos;
    
}


/*************************** Start - price validation ***************************/

$("#price_to").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

    $("#price_from").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

/*
jQuery('#price_to').keypress(function(event) {
  if ((event.which != 46 || jQuery(this).val().indexOf('.') != -1) &&
    ((event.which < 48 || event.which > 57) &&
      (event.which != 0 && event.which != 8))) 
  {
    event.preventDefault();
  }
  var text = $(this).val();

  if ((text.indexOf('.') != -1) &&
    (text.substring(text.indexOf('.')).length > 2) &&
    (event.which != 0 && event.which != 8) &&
    (jQuery(this)[0].selectionStart >= text.length - 2)) 
  {
    event.preventDefault();
  }
});
*/

/*************************** End - price validation ***************************/

    function replace_price_to(){
      
        if(jQuery('#price_to').val()==''){
            var value = parseFloat(jQuery('#price_right_hidden').val()); 
            jQuery('#price_to').val(currency_symbol+" "+numberWithCommas(value.toFixed(0)));
          	return false;
        } else {
            var value =jQuery('#price_to').val();
        }
     
        var value1=jQuery('#price_from').val();
		//alert(value1//);//
        value=value.replace(/[^\d\.]/g, '');
        value1=value1.replace(/[^\d\.]/g, '');

        value=parseInt(value);
        value1=parseInt(value1);
      
      // alert(jQuery('#price_to').val());
      if(isNaN(value)!=false){
           var value = maxDiamondPrice;
           alert("Please enter value in number");
           jQuery('#1000000').val(currency_symbol+value);
        }
      else if(value > maxDiamondPrice){         
           alert('Price from should be less than '+currency_symbol+numberWithCommas(parseFloat(maxDiamondPrice).toFixed(0)));
          var valLimit = parseFloat(jQuery('#price_right_hidden').val());
          jQuery('#price_to').val(currency_symbol+""+numberWithCommas(valLimit.toFixed(0)));
          return false;
        } else if(value1> value){ 
             alert('Price from should be less than '+currency_symbol+minDiamondPrice);
            var valLimit = parseFloat(jQuery('#price_right_hidden').val());
          	jQuery('#price_to').val(currency_symbol+""+numberWithCommas(valLimit.toFixed(0)));
            return false;
        }else if(value1==''){
            jQuery('#price_from').val(value1);
        }
     
        jQuery('#price_right_hidden').val(value.toFixed(0));
        jQuery('#price_left_hidden').val(value1.toFixed(0));
        price_slider_render(value1,value,true);
    
    }

    function replace_price_from(){
      	if(jQuery('#price_from').val()==''){
         // alert(1);
            var value = parseFloat(jQuery('#price_left_hidden').val()); 
            jQuery('#price_from').val(currency_symbol+""+numberWithCommas(value.toFixed(0)));
           	return false;
        } else{
            var value =jQuery('#price_from').val();
        }
        var value1=jQuery('#price_to').val();  
        console.log(value);
        value=value.replace(/[^\d\.]/g, '');
        value1=value1.replace(/[^\d\.]/g, '');
      console.log(value);
      console.log(value1);
        value=parseInt(value);
        value1=parseInt(value1);
      
     // alert(value+'--'+value1);
        if(isNaN(value)!=false){
           var value = minDiamondPrice;
           alert("Please enter value in number");
           jQuery('#price_from').val(currency_symbol+value);
        }
       else if(value < minDiamondPrice){        
          alert('Price from should be greater than '+currency_symbol+minDiamondPrice);
          var valLimit = parseFloat(jQuery('#price_left_hidden').val()); 
          jQuery('#price_from').val(currency_symbol+""+numberWithCommas(valLimit.toFixed(0)));
          return false;
        } else if(value > value1){
          
           alert("Price from should be less than "+currency_symbol+numberWithCommas(parseFloat(value1).toFixed(0)));
          price_slider_render(price[0],value1,true);
          return false;
        }
      	
        jQuery('#price_left_hidden').val(value.toFixed(0));
        jQuery('#price_right_hidden').val(value1.toFixed(0));
        price_slider_render(value,value1,true);
    
    }
/************************** End - Diamond Price Filter **************************/

/************************** Start - Diamond sorting Filter **************************/
function sorting_data(sorting,className){ 
	 
	var sortorder='';
  	var clas = className;

    jQuery('.datagrid-sort').each(function(){	
  	 	if(jQuery(this).hasClass('fa-angle-up')){
            jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');  
        }      
    });
  
  	if((mySelection[1]==sorting) && (mySelection[2]=='ASC')){
		sortorder='DESC';
      	jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');	
  	}else{
  		sortorder='ASC';
      	jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');	
    }  
  	jQuery('#sort_call').val(sorting);
  	jQuery('#sort_dir').val(sortorder);
  
  	
  
  	mySelection[1]=jQuery('#sort_call').val();
	mySelection[2]=jQuery('#sort_dir').val();
  	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
    ajaxDataCall(1);
 }
/************************** End - Diamond sorting Filter **************************/

/************************** Start - Diamond depth Filter **************************/
var depth=[];

for(i=45;i<90;i=i+0.10)
{
  var dec=i.toFixed(2);
  depth.push(dec);
}
function depth_slider_render(start,end,option){ 
  //console.log(start+"--"+end+"--"+option);
    var start2=getClosestNum(start,depth);
	var end2=getClosestNum(end,depth);
	var start1=get_index(start2,depth); 
	var start11=get_index(start,depth);
	var end11=get_index(end,depth);
	var end1=get_index(end2,depth);
  //console.log(start+"--"+end+"--"+start1+"--"+end1+"--"+start2+"--"+end2+"--"+start11+"--"+end11);
		jQuery("#depth-slider").slider({
			range: true,
			min: 0,
			max: depth.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
              		if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				
				$("#depth_from").val(depth[parseInt(ui.values[0])]+'%');
				$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
				$('#depth_to').val(depth[parseInt(ui.values[1])]+'%');
				$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
          		if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				$("#depth_from").val(depth[parseInt(ui.values[0])]+'%');
				$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
				$('#depth_to').val(depth[parseInt(ui.values[1])]+'%');
				$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
			
              if(option) {	
				   	jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
                   	ajaxDataCall(1);
              }
			}
			 
		});
  
  		var Start_limit = parseFloat(start);  	
  		var End_limit = parseFloat(end);
  
		 $("#depth_from").val(Start_limit.toFixed(2)+'%');
		 $("#depth_to").val(End_limit.toFixed(2)+'%');
		 $('#depth_left_hidden').val(start);
		 $('#depth_right_hidden').val(end);
		
	
}

function replace_depth_from(){
 
  var min_depth_value = 45.00;
  
  if(jQuery('#depth_from').val()==''){
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  } else{
    var depth_value=parseFloat(jQuery('#depth_from').val());
    var hidden_depth_value = $('#depth_left_hidden').val();
  }
  //  alert(depth_value);
 // var value = depth_value.replace(/%\./g, '');
  // var depth_value1_comma = value.replace(/[^0-9\.,]+/g, ''); 
 // value = depth_value1_comma.replace(',', '.'); 
  var value = depth_value;
  //alert(value);
  
  var depth_value1_comma = value;   
  value = depth_value1_comma; 
  
  var value1=parseFloat($('#depth_to').val());
 // alert(value+'--'+value1);
  /* if(value == value1){ 
    alert('Depth from value should be less than depth to value'); 
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  } else */
  if(isNaN(value)!=false){
     var value = 45.00;
     alert("Please enter value in number");
     jQuery('#depth_from').val(value+'%');
  }
  else if(value > value1){ 
    alert('Depth from value should be less than depth to value'); 
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  }else if(depth_value < min_depth_value){
        alert('Depth from value should be greater than depth from value'); 
    $('#depth_from').val(min_depth_value+"%");
    depth_slider_render(min_depth_value,value1,true);
    return false;
  }

  $('#depth_left_hidden').val(value);
  $('#depth_right_hidden').val(value1);

  depth_slider_render(value,value1,true);

}

function replace_depth_to(){

  var max_depth_value = 90;
  
  if(jQuery('#depth_to').val()==''){
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  } else{
    var depth_value= parseFloat(jQuery('#depth_to').val());
    var hidden_depth_value = $('#depth_right_hidden').val();
  }

 // value = depth_value.replace(/%\./g, '');
//   var depth_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = depth_value1_comma.replace(',', '.'); 
//   var value = depth_value;
  //alert(value);
//   if(isNaN(value)!=false){
//      var value = 90.00;
//    // alert(value);
//      jQuery('#depth_to').val(value+'%');
//   }
  value = depth_value;
  var depth_value1_comma = value;   
  value = depth_value1_comma; 

  var value1=parseFloat($('#depth_from').val());

  /* if(value1 == value){ 
    alert('Depth to value should be greater than depth from value'); 
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  } else */
   if(isNaN(value)!=false){
     var value = 90.00;
   alert('Please enter value in number');
     jQuery('#depth_to').val(value+'%');
  }
  else if(value1> value){ 
     alert('Depth to value should be greater than depth from value');  
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  }else if(value > max_depth_value)
  {
     alert('Depth to value should be less than depth to value'); 
    $('#depth_to').val(max_depth_value+"%");
    depth_slider_render(value1,max_depth_value,true);
    return false;
  }

  $('#depth_right_hidden').val(value);
  $('#depth_left_hidden').val(value1);
  
  depth_slider_render(value1,value,true);
}
/************************** End - Diamond depth Filter **************************/

/************************** Start - Diamond table Filter **************************/
var table=[];

for(i=45;i<90;i=i+0.10)
{
  var dec=i.toFixed(2);
  table.push(dec);
}
function table_slider_render(start,end,option){ 
  //console.log(start+"--"+end+"--"+option);
    var start2=getClosestNum(start,table);
	var end2=getClosestNum(end,table);
	var start1=get_index(start2,table); 
	var start11=get_index(start,table);
	var end11=get_index(end,table);
	var end1=get_index(end2,table);
  //console.log(start+"--"+end+"--"+start1+"--"+end1+"--"+start2+"--"+end2+"--"+start11+"--"+end11);
		jQuery("#table-slider").slider({
			range: true,
			min: 0,
			max: table.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) {
                if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				
				$("#table_from").val(table[parseInt(ui.values[0])]+'%');
				$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
				$('#table_to').val(table[parseInt(ui.values[1])]+'%');
				$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) {
                if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				$("#table_from").val(table[parseInt(ui.values[0])]+'%');
				$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
				$('#table_to').val(table[parseInt(ui.values[1])]+'%');
				$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
			
              if(option) {	
				   	if(option==true) {
	 				jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
           			ajaxDataCall(1);
	 			}
                   	
                
              }
			}
			 
		});
  
  
    var Start_limit = parseFloat(start);  	
    var End_limit = parseFloat(end);

    $("#table_from").val(Start_limit.toFixed(2)+'%');
    $("#table_to").val(End_limit.toFixed(2)+'%');

    $('#table_left_hidden').val(start);
    $('#table_right_hidden').val(end);
		
	
}

function replace_table_from(){ 
  
  var min_table_value = 45;
  
  if(jQuery('#table_from').val()==''){
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  } else{
    var table_value= parseFloat(jQuery('#table_from').val());
    var hidden_table_value = $('#table_left_hidden').val();
  }
  
//   var value = table_value.replace(/%\./g, '');
//   table_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = table_value1_comma.replace(',', '.'); 
  var value = table_value;
  var table_value1_comma = value;   
  value = table_value1_comma; 


  var value1=parseFloat($('#table_to').val());

  /* if(value == value1){ 
    alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  } else */ 
   if(isNaN(value)!=false){
     var value = 45.00;
    alert('Please enter value in number');  
     jQuery('#table_from').val(value+'%');
  }
  else if(value> value1){ 
    alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  }else if(table_value < min_table_value){
     alert('Table from value should be greater than table from value'); 
    $('#table_from').val(min_table_value+"%");
    table_slider_render(min_table_value,value1,true);
    return false;
  }
  
  
  $('#table_left_hidden').val(value);
  $('#table_right_hidden').val(value1);

  table_slider_render(value,value1,true);

}

function replace_table_to(){

  // var hidden_table_value = $('#table_right_hidden').val(); 
  // var table_value=$('#table_to').val();
  var max_table_value = 90;
    
  if(jQuery('#table_to').val()==''){
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else{
    var table_value= parseFloat(jQuery('#table_to').val());
    var hidden_table_value = $('#table_right_hidden').val();
  }
  
//   value = table_value.replace(/%\./g, '');
//   table_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = table_value1_comma.replace(',', '.'); 
  
   value = table_value;
  var table_value1_comma = value;   
  value = table_value1_comma; 

  var value1=parseFloat($('#table_from').val());

  /* if(value == value1){ 
    alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else */
  if(isNaN(value)!=false){
     var value = 90.00;
    alert('Please enter value in number');  
     jQuery('#table_to').val(value+'%');
  }
  else if(value1> value){ 
    alert('Table to value should be greater than table from value');  
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else if(value > max_table_value) {
    $('#table_to').val(max_table_value+"%");
    table_slider_render(value1,max_table_value,true);
    return false;
  }

  $('#table_right_hidden').val(value);
  $('#table_left_hidden').val(value1);
  
  table_slider_render(value1,value,true);
}
/************************** End - Diamond table Filter **************************/

/************************** Start - Diamond Add To Cart  **************************/
function buy_now(){
	var diamond_id= $("#selectDiamondID").val(); 
  	var diamond_price= $("#selectDiamondPrice").val();
    var diamond_shape= $("#selectDiamondShape").val();
    var diamond_lab= $("#selectDiamondLab").val();
    var diamond_certno= $("#selectDiamondCertNo").val();
    var diamond_name= $("#selectDiamondName").val();
    var diamond_type= $("#dia_searchtype").val();
    var diamond_carat= $("#selectDiamondCarat").val();
    var diamond_color= $("#selectDiamondColor").val();
    var diamond_clarity= $("#selectDiamonClarity").val();
	var diamond_intensity= $("#selectDiamonIntensity").val();
	var data = {
		"action": "add_to_cart",
		"diamond_id": diamond_id,
      	"diamond_price":diamond_price,
      	"diamond_shape":diamond_shape,
        "diamond_lab":diamond_lab,
        "diamond_certno":diamond_certno,
        "diamond_name":diamond_name,
      	"diamond_type":diamond_type,
        "diamond_carat":diamond_carat,
        "diamond_color":diamond_color,
        "diamond_clarity":diamond_clarity,
      	"diamond_intensity":diamond_intensity
	};
	//console.log(data);
	$.ajax({
		url: "https://app.kurajewellerylondon.com/shopify_api/add_to_cart_kura-jewellery.php?public-api-key=aa502242fff0fec7463a3c9651e5310d",
    	type: "POST",
		ascync : false,
		data: data,
		dataType: "json",
		beforeSend: function(){
			jQuery("#loading").show();
		},
		success: function (result) {
			jQuery("#loading").hide();
			variant_id=result.variants[0]['id'];
          //alert(variant_id);
          	setTimeout(addtocart(variant_id), 5000);
			//addtocart(variant_id);
		},
		error: function (xhr, ajaxOptions, thrownError) {
         //alert(xhr.status);
         //alert(thrownError);
     }
 });
}


function addtocart(add_id){
  jQuery.post('/cart/add.js', {
    quantity:1,
    id: add_id,
  });
  animate();

}

/************************** End - Diamond Add To Cart  **************************/

function animate() {
  
	var elem=$(".chooseDiamondLink");
	var quantity=1;
	$("#cart-animation").show();

	var addtocartWidth = elem.outerWidth() / 2
	var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = 0;//elem.offset().left + addtocartWidth;
        var addtocartTop = 0;//$(elem).offset().top + addtocartHeight ;

        var buttonAreaWidth = $(".header-bar__cart-icon").outerWidth();
        var buttonAreaHeight =$(".header-bar__cart-icon").outerHeight();

        var buttonAreaLeft = 0;//($(".header-bar__cart-icon").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4 - 18;
        var buttonAreaTop =0;// ($(".header-bar__cart-icon").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 - 8;

        var path = {
        	start: {
        		x: addtocartLeft,
        		y: addtocartTop,
        		angle: 190.012,
        		length: 0.2
        	},
        	end: {
        		x: buttonAreaLeft,
        		y: buttonAreaTop,
        		angle: 90.012,
        		length: 0.50
        	}
        };

        $('#cart-animation').val(quantity).animate(
        {
          //path : new $.path.bezier(path)
      },
      1000,
      
      function() {
      	$("#cart-animation").fadeOut(500, function() {
       		$(elem).prop("disabled", false)
            //var cartCount =  parseInt($('#cart-count').text()) + quantity;
            window.location.href = "/cart";
            //$('#cart-count').text(cartCount)
            //$('.header-bar__cart-icon').addClass('has-items');
            
        })
      } 
      
      );
    }


/************************** Start - Reset Filters  **************************/
function reset_cookies()
{    
    localStorage.setItem("white_dia_shape",'');
    localStorage.setItem("white_min_price", "100");
    localStorage.setItem("white_max_price", "2500000");
    localStorage.setItem("white_min_carat", minDiamondCarat);
    localStorage.setItem("white_max_carat", maxDiamondCarat);
    localStorage.setItem("white_min_cut",'0');
    localStorage.setItem("white_max_cut",'5');
    localStorage.setItem("white_min_color",'0');
    localStorage.setItem("white_max_color",jQuery("#color-max-value-slide").val());
    localStorage.setItem("white_min_clarity", "0");
    localStorage.setItem("white_max_clarity", "8");
    localStorage.setItem("white_min_polish",'0');
    localStorage.setItem("white_max_polish",'3');
    localStorage.setItem("white_min_symmetry",'0');
    localStorage.setItem("white_max_symmetry",'3');
    localStorage.setItem("white_min_flour",'0');
    localStorage.setItem("white_max_flour",'5');
    localStorage.setItem("white_min_depth",'45');
    localStorage.setItem("white_max_depth",'90');
    localStorage.setItem("white_min_table",'45');
    localStorage.setItem("white_max_table",'90');
    localStorage.setItem("white_lab",'');
  	localStorage.setItem("white_compare_ids",'');
  
//   	localStorage.setItem("fancy_dia_shape",'');
//     localStorage.setItem("fancy_min_price", "100");
//     localStorage.setItem("fancy_max_price", "2500000");
//     localStorage.setItem("fancy_min_carat", "0.22");
//     localStorage.setItem("fancy_max_carat", "15.00");
//     localStorage.setItem("fancy_min_intensity",'0');
//     localStorage.setItem("fancy_max_intensity",'8')
//     localStorage.setItem("fancy_lab",'');
    localStorage.setItem("fancy_dia_color",'');
    localStorage.setItem("fancy_compare_ids",''); 
}



function caratposition(carat){
     var screenwidth=jQuery(document).width();
     var initwidth=1.5;
     var interval=1;
     var width=90; //if not match any
    if(carat > 0.25 &&  carat <= 0.5){
      interval=0.40;
      width=(carat*100)-25;
      width=initwidth+(width*interval); 
     }else if(carat > 0.50 &&  carat <= 0.75 ){
      interval=0.40;
      width=(carat*100)-25;
      width=initwidth+(width*interval); 
     }else if(carat > 0.75 &&  carat <= 1.0 ){
      interval=0.50;
      width=(carat*100)-25;
      width=initwidth+(width*interval); 
     }else if(carat > 1.0 &&  carat <= 1.25 ){
      interval=0.40;
      width=(carat*100)-25;
      width=initwidth+(width*interval)-5; 
     }else if(carat > 1.25 &&  carat <= 1.75 ){
      interval=0.50;
      width=(carat*100)-25;
      width=initwidth+(width*interval); 
     }
     else if(carat > 1.75 &&  carat <= 2){
      interval=0.50;
      width=(carat*100)-25;
      width=initwidth+(width*interval); 
     } /*else if(carat > 2 &&  carat <= 2.5){
      interval=0.50;
      initwidth=56;
      width=(carat*100)-200;
      width=initwidth+(width*interval); 
     }else if(carat > 2.5 &&  carat <= 3){
        interval=0.16;
        initwidth=75;
        width=(carat*100)-200;
        width=initwidth+(width*interval); 
     }*/
     
     if(screenwidth < 485){
      width= width-2;
     }
     return width;
}



function colorPosition(color){
  var width = 0;
  if(color == 'D'){
    width = 0;
  }else if(color == "G"){
    width = 41;
  }else if(color == "J"){
    width = 84;
  }/*else if(color == "K"){
    width = 41.5;
  }*/else if(color == "H"){
    width = 56;
  }else if(color == "E"){
    width = 13;
  }else if(color == "F"){
    width = 28;
  }else if(color == "I"){
    width = 70;
  }
  return width;
}

/************************** End - Reset Filters  **************************/


/*** sticky product ****/


window.onscroll = function() {myFunction()};


function myFunction() {
  /*if (window.innerWidth > 767) {*/
    var header = document.getElementsByClassName("steps_container")[0];
    if(header){
      var sticky = header.offsetTop;
      var footer = header.offsetHeight - 300;
      var breadcrumb = document.getElementsByClassName("tps_breadcrumb")[0];
      
      var headerHeight = document.getElementsByClassName("hd-Header")[0].offsetHeight ;
      if (window.pageYOffset > sticky ) {
        header.classList.add("sticky");
        document.getElementsByClassName("steps_container")[0].style.top = headerHeight+"px";
        breadcrumb.classList.add("remove-breadcrumb-fixed");
      } else {
        header.classList.remove("sticky");
        document.getElementsByClassName("steps_container")[0].style = "";
        breadcrumb.classList.remove("remove-breadcrumb-fixed");
      }
    }
  /*}*/
}





   function getbackgorundwidth(diamondcarat){
      var backgroundwidth =0 ;
      if(diamondcarat >= 0.20 && diamondcarat <= 0.39){
          var index = calib1.indexOf(diamondcarat);
          backgroundwidth = 22.4457+index*0.022878947+4; 
      }else if(diamondcarat >= 0.40 && diamondcarat <= 0.59){
          var index = calib2.indexOf(diamondcarat);
          backgroundwidth = 25.9239+index*0.008584211+4; 
      }else if(diamondcarat >=0.60 && diamondcarat <= 0.84){
          var index = calib3.indexOf(diamondcarat);
          backgroundwidth = 31.8478+index*0.002266667+4;
      }else if(diamondcarat >=0.85 && diamondcarat <= 1.10){
          var index = calib4.indexOf(diamondcarat);
          backgroundwidth = 32.5543+index*0.019564+4;
      }else if(diamondcarat >=1.11 && diamondcarat <= 1.34){
          var index = calib5.indexOf(diamondcarat);
          backgroundwidth = 37.2283+index*0.009452174+4; 
      }else if(diamondcarat >=1.35 && diamondcarat <= 1.80){
          var index = calib6.indexOf(diamondcarat);
          backgroundwidth = 39.6196+index*0.004831111+4; 
      }else if(diamondcarat >=1.81 && diamondcarat <= 2.25){
          var index = calib7.indexOf(diamondcarat);
          backgroundwidth = 43.75+index*0.002470455+4; 
      }else if(diamondcarat >=2.26 && diamondcarat <= 2.79){
          var index = calib8.indexOf(diamondcarat);
          backgroundwidth = 48.0435+index*0.0030754717+4;  
      }else if(diamondcarat >=2.80 && diamondcarat <= 3.49){
          var index = calib9.indexOf(diamondcarat);
          backgroundwidth = 50.2174+index*0.00157536232+4;
      }else if(diamondcarat >=3.50 && diamondcarat <= 4.49){
          var index = calib10.indexOf(diamondcarat);
          backgroundwidth = 55.0543+diamondcarat*1.021959596+4; 
      }else if(diamondcarat >=4.50 && diamondcarat <= 6.00){
          var index = calib11.indexOf(diamondcarat);
          backgroundwidth = 58.75+diamondcarat*1.40+4;

      }else{
        backgroundwidth=59.1305;
      }
      return backgroundwidth;
}


function getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');

            if($.inArray(hash[0], vars)>-1)
            {
                vars[hash[0]]+=","+hash[1];
            }
            else
            {
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
        }

        return vars;
    }

function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

	var listscroll = 0;
$(document).ready(function(){
	if($('.tps_settinglisting').length ){
       $(window).bind('scroll', function() {
         if($(window).scrollTop() >= $('.tps_settinglisting').offset().top + $('.tps_settinglisting').outerHeight() - window.innerHeight) {
           if($(".load_more").is(":visible")){
             if(listscroll == 0){
                  listscroll = 1;
                  $('.load_more').click();
             }
           }

         }
      });
    }
});
function setSelectedFilter(filter_value,func,hasSelectedClass,input_value=''){      
    if(input_value == 'price'){
    	$('.selected_filter_container').find('li[data-input="price"]').remove();
    }
    var value = filter_value.split(':');
    if(hasSelectedClass){      
		var html = '';
		html += '<li onclick="'+func+'" data-input="'+input_value+'" data-filter_value="'+filter_value+'">'+value[1].trim()+'<span class="fa fa-close"></span></li>';
  		if($('#'+value[0]+'_container').length > 0){
      		$('#'+value[0]+'_container').append(html);
        }else{
          var elecontainer = '<ul id="'+value[0]+'_container"><span>'+value[0]+':</span></ul>';
        	$('.selected_filter_container').append(elecontainer);
			$('#'+value[0]+'_container').append(html);
        }
    }else{
    	$('.selected_filter_container').find('li[data-filter_value="'+filter_value+'"]').remove();
        if($('input[value="'+input_value+'"]').length > 0){
              $('input[value="'+input_value+'"]').prop('checked', false);          	
        }
      if($('#'+value[0]+'_container li').length == 0){
      		$('#'+value[0]+'_container').remove();
      }
    }
    if($('.selected_filter_container li').length > 0){
      	$('.tps_selected_filter_wrapper').show();
    }else{
    	$('.tps_selected_filter_wrapper').hide();
    }
  }
function isImage(file){
  
    var valid_extensions = /(\.jpg|\.jpeg|\.gif|\.png)$/i;   
    if(valid_extensions.test(file))
    { 
       return true
    }
    else
    {
       return false
    }
}